import React from "react";
import { StatusBadge } from "../app";
import { Progress } from "../ui/progress";

export function createProjectColumns({
  t,
  getClientName,
  calculateProgress,
  projectActions,
}) {
  return [
    {
      id: "name",
      header: t("projectName"),
      cellClassName: "text-[#F3F4F6] font-medium",
      render: (project) => project.name,
      hideOnMobile: true,
    },
    {
      id: "client",
      header: t("client"),
      cellClassName: "text-[#9CA3AF]",
      render: (project) => getClientName(project.client_id),
      hideOnMobile: true,
    },
    {
      id: "status",
      header: t("status"),
      render: (project) => <StatusBadge value={project.status} />,
      hideOnMobile: true,
    },
    {
      id: "priority",
      header: t("priority"),
      render: (project) => <StatusBadge value={project.priority} />,
    },
    {
      id: "budget",
      header: t("budget"),
      cellClassName: "text-[#9CA3AF]",
      mobileClassName: "text-[#9CA3AF]",
      render: (project) => `$${project.budget?.toLocaleString() || 0}`,
    },
    {
      id: "progress",
      header: t("progress"),
      render: (project) => (
        <div className="flex items-center gap-2">
          <Progress value={calculateProgress(project)} className="h-2 w-20 bg-[#242E42]" />
          <span className="text-xs text-[#9CA3AF]">
            {calculateProgress(project).toFixed(0)}%
          </span>
        </div>
      ),
    },
    {
      id: "actions",
      header: t("actions"),
      actions: true,
      render: projectActions,
    },
  ];
}
